var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"overflow":"hidden","height":"100%","width":"100%"},attrs:{"src":"https://picayune-record-a8e.notion.site/Help-fbdff2d5d028463fa846b008ba3c5d43","frameborder":"0","height":"100%","width":"100%"}})}
var staticRenderFns = []

export { render, staticRenderFns }